/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../Container/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Link } from "react-router";
import Typography from "@mui/material/Typography";
import jobSectionStyle from "./jobsSectionStyle";
import { Box, Paper } from "@mui/material";

const JobsSection = () => {
  return (
    <Box id={"jobs"}>
      <Container sx={jobSectionStyle.container}>
        <Typography variant={"h1"} component={"h3"} sx={jobSectionStyle.headline}>
          Wen wir suchen
        </Typography>
        <Grid container>
          <Grid size={12}>
            <Paper
              component={Grid}
              container
              sx={{
                ...jobSectionStyle.job,
                alignItems: "center",
                justifyContent: "space-between",
              }}
              elevation={0}
            >
              <Box>Teamleitung Legal Operations / Kanzleimanagement Vollzeit (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/kanzleimanagement-teamleitung-mwd"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
          <Grid size={12}>
            <Paper
              component={Grid}
              container
              sx={{
                ...jobSectionStyle.job,
                alignItems: "center",
                justifyContent: "space-between",
              }}
              elevation={0}
            >
              <Box>Rechtsanwaltsfachangestellte/r Vollzeit (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/rechtsanwaltsfachangestellter-mwd"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
          <Grid size={12}>
            <Paper
              component={Grid}
              container
              sx={{
                ...jobSectionStyle.job,
                alignItems: "center",
                justifyContent: "space-between",
              }}
              elevation={0}
            >
              <Box>Rechtsanwältin/Rechtsanwalt (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/rechtsanwalt-mwd"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
          <Grid size={12}>
            <Paper
              component={Grid}
              container
              sx={{
                ...jobSectionStyle.job,
                alignItems: "center",
                justifyContent: "space-between",
              }}
              elevation={0}
            >
              <Box>Wirtschaftsjuristin/Wirtschaftsjurist (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/wirtschaftsjurist-mwd"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
          <Grid size={12}>
            <Paper
              component={Grid}
              container
              sx={{
                ...jobSectionStyle.job,
                alignItems: "center",
                justifyContent: "space-between",
              }}
              elevation={0}
            >
              <Box>Rechtsreferendarin / Rechtsreferendar (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/rechtsreferendar-mwd"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
          <Grid size={12}>
            <Paper
              component={Grid}
              container
              sx={{
                ...jobSectionStyle.job,
                alignItems: "center",
                justifyContent: "space-between",
              }}
              elevation={0}
            >
              <Box>Product Manager Legal Tech (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/productmanager-legaltech-mwd"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
          <Grid size={12}>
            <Paper
              component={Grid}
              container
              sx={{
                ...jobSectionStyle.job,
                alignItems: "center",
                justifyContent: "space-between",
              }}
              elevation={0}
            >
              <Box>Senior Developer (m/w/d)</Box>
              <Button sx={jobSectionStyle.button} component={Link} to={"/jobs/developer-mwd"} color={"primary"}>
                mehr erfahren
              </Button>
            </Paper>
          </Grid>
        </Grid>
        <br />
      </Container>
    </Box>
  );
};

export default JobsSection;
